import './bootstrap';
import '../css/layers.css';
import 'vuetify/styles';
import '../css/app.scss';
import {bootstrapApp} from './bootstrapApp';
import {suppressKnownWarnings} from './utils/suppressKnownWarnings';
import {initStaleAssetReloadHandlers} from './utils/staleAssetReload';
import {initEmbedHeightReporter} from './utils/embedMessaging';
import {isStorefrontPreview} from './utils/storefrontPreview';

suppressKnownWarnings();
initStaleAssetReloadHandlers();
initEmbedHeightReporter();
// Record ?preview=1 for this tab before any redirect can drop the query string.
isStorefrontPreview();

bootstrapApp().catch(console.error);
